import React, { useEffect, useState } from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import SubmitResources from "../submitResources";
import resourceIcon from "../../assets/images/resource_icon.svg";
import levelIcon from "../../assets/images/level_icon.svg";
import timeIcon from "../../assets/images/time_icon.svg";
import calendarIcon from "../../assets/images/calendar_icon.svg";
import billingIcon from "../../assets/images/billing_icon.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import Table from "../../components/selectTable";
import SearchBar from "../../components/searchbar";

import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
} from "@progress/kendo-react-grid";
import { Error } from "@progress/kendo-react-labels";
import { Navigate, useNavigate } from 'react-router-dom';
import { checkPriority, convertMilliSecToDateNew, priorityClass } from '../../utils/EllowUtils';
import ResourceFilter from '../../modal/resourceFilter';
import NotificationAlert from '../../components/notification';
import {getProviderResources , getRecruiterResources} from './services'

interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}




function ApplyPositions(props: any) {


  const jobId = props.jobId
  const [filterValues, setFiltervalues] = useState<any>()
  const [error, setError] = useState<string>()
  const [count, setCount] = useState<number>(0)
  const [total, setTotal] = useState<number>()
  const [jobMetadata, setJobMetadata] = useState<{
    resourceCount: number , priority:number, experienceRange: {min: number , max: number}  , contractDuration : string , contractStartDate: number , minimumBudget: any , maximumBudget: any ,
      billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}]
  }>({
    resourceCount: 0, priority:5, experienceRange: {min: 0 , max: 12}  , contractDuration: "" , contractStartDate: 0 , minimumBudget: 0 , maximumBudget: 0 ,
      billingType: "",jobRole: {id: 0, name: ""} , coreSkills: [{skillId: 0, skillName: ""}] , otherSkills: [{skillId: 0, skillName: ""}]
  })

  const [selectedCandidates, setSelectedCandidates] = useState([])
  const [submitResources, setSubmitResources] = useState<boolean>(false)
  const [filter, setFilter] = useState<boolean>(false)
  let navigate = useNavigate()


  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state, setState] = useState<AppState>(createState(0, 25, props.data));
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  useEffect(() => {

    setState(createState(state.skip, state.pageSize, props.data));
    setJobMetadata(props.jobMetadata)  
    // let filtervalues = {
    //   experience: {
    //     from: props && props.filtervalues && props.filtervalues.experience.min,
    //     to: props && props.filtervalues && props.filtervalues.experience.max
    //   } ,
    //   core_skills: props && props.filtervalues && props.filtervalues.core_skills
    // }
    //  setFiltervalues(filtervalues)
  }, [props.total, props.data, props.jobMetadata, props.filtervalues])

  useEffect(() => {
    if (props.fail) {
      setSubmitResources(false)
      setMessage('Resource cost of the candidate is not filled')
      setNotification(true)
      setTimeout(() => {
        setNotification(false)
       }, 3000)  
    }
    else {
      setSubmitResources(false)   
    }
  },[props.fail])




  const pageChange = (event: GridPageChangeEvent) => { 
    setState(createState(event.page.skip, event.page.take, props.data));
    
    props.pageSize(event.page.take, event.page.skip) 
  }
  
  const pageSize = (pageSize:any, pageNumber: number) => { 
    props.pageSize(pageSize, pageNumber)
  }
  

  const onSubmit = (data: any) => { 
    if (data) {
      props.onSubmit(data)
    }
    
  }

  const onSelection =  (data: any) => {
    setSelectedCandidates(data) 
    setCount(data.length)
    setError('')
    
  }
  let verified: any = [];
  let basic: any = [];
  let full: any = [];
  // const submitResource = () => {
  //   if (selectedCandidates && selectedCandidates.length > 0) {
  //     const valid = selectedCandidates.map((item: any) => {
  //       return (
  //         item.candidateStatus === 'F3 - Verified' ? true : false
  //       )
  //     })
  //     if (valid.includes(false)) {
  //       displayNotification('Candidate selected is not Verified')
  //     }
  //     else {
  //        setSubmitResources(true) 
  //     }
  //   }else {
  //     setError('Select atleast one resource')
  //   }
  // }
  
  const submitResource = () => {
    if (selectedCandidates && selectedCandidates.length > 0) {
      selectedCandidates.forEach(checkFunction)
      
      if (basic.length > 0) {
        displayNotification('Please verify the candidate and the change the ellow status to verified before submission')
      }

      if (full.length > 0) {
        displayNotification('Please complete full profile and verify before applying ')
      }

      if (verified.length > 0 && basic.length === 0 && full.length ===0) {
        setSelectedCandidates(verified)
        setSubmitResources(true)  
      }
      
    }
  }


  const checkFunction = (data: any) => {
    if (data.ellowStatus === 'F3 - Verified') {
       verified.push(data)
    }
    if (data.ellowStatus === 'F1 - Basic profile submitted') {
      basic.push(data)
    }
    if (data.ellowStatus === 'F2 - Full profile submitted') {
      full.push(data)
    }
  }

  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      if (verified.length > 0) {
        setSelectedCandidates(verified)
        setSubmitResources(true)
      }
     }, 3000)  
  }

  const onRowClick = (data: any) => {
    setSelectedCandidates(data)
  }

    return (
      <>
      {notification && <NotificationAlert onClose={() => setNotification(false) } closable={true} type={'error'} icon={false}>
        {message}
      </NotificationAlert> }
        <div className="table-content-wrapper">
          <h3 className="headWithLabel">
            Job Description<label className={jobMetadata && priorityClass(jobMetadata.priority)}>{jobMetadata && checkPriority(jobMetadata.priority) }</label>
          </h3>
          <div className={Styles.jobStatusWrap}>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={resourceIcon} />
              </figure>
              <figcaption>Resources Required</figcaption>
              <h2>{jobMetadata && jobMetadata.resourceCount}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={levelIcon} />{" "}
              </figure>
              <figcaption>Experience Level</figcaption>
          <h2>{jobMetadata && jobMetadata.experienceRange  ?  jobMetadata.experienceRange.min +" - "+ jobMetadata.experienceRange.max +' Years' : 'Not Mentioned'}</h2>
              
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={timeIcon} />
              </figure>
              <figcaption>Contract Duration</figcaption>
              <h2>{jobMetadata && jobMetadata.contractDuration !== '' ? <h2>{jobMetadata.contractDuration}</h2> : 'Not Mentioned' }</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={calendarIcon} />
              </figure>
              <figcaption>Start Date</figcaption>
              <h2>{jobMetadata && jobMetadata.contractStartDate && jobMetadata.contractStartDate !== 0 ? convertMilliSecToDateNew(jobMetadata.contractStartDate) : 'Immediate'}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={billingIcon} />
              </figure>
              <figcaption>Billing Rates</figcaption>
              <h2>{jobMetadata && jobMetadata.minimumBudget !== '' ?
              <h2>{jobMetadata.minimumBudget} ₹ - {jobMetadata.maximumBudget} ₹/ {jobMetadata && jobMetadata.billingType}</h2> :'Not Mentioned'}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img src={crownIcon} />
              </figure>
              <figcaption>Job Role</figcaption>
              <h2><h2>{jobMetadata && jobMetadata.jobRole.name}</h2></h2>
            </div>
            
          </div>
        </div>
        <section className={Styles.dashboardWrapper}>
          <div className="table-content-wrapper">
          <div className={Styles.resourceHead}>
            <div className="tableHead">
                <div className="tableTitle">
                  <h2>Resources</h2>
                  <p>{`${count} Resources Selected`}</p>
                </div>
                <Button onClick={submitResource} variant="primary" size="small">
                Apply for this Position
              </Button>
            </div> 
            <div className={Styles.resourceSearch}>
                <SearchBar  searchChange={props.searchChange} filtervalues={props.filtervalues} onClick={() => setFilter((prev) => !prev)} tagClose={props.closeTag} />
            </div>
          </div>
          <Error>{error}</Error>
           
          <Table data={props.data} type={'positions'} total={props.total} state={state} pageChange={pageChange}  pageSize={pageSize} onSelection={onSelection} onRowClick={onRowClick}/>
          </div>
        </section>
        {filter && <ResourceFilter onClose={() => setFilter(false)} defaultValues={props.filtervalues} allocatedTo={props.allocatedTo} ClickHandler={(data: any) => { props.applyFilter(data); setFilter(false) }} getProviderResources={getProviderResources} getRecruiterResources={getRecruiterResources} skillsList={props.skillsList } jobRolesList={props.jobRolesList} />}
     

        {submitResources && <SubmitResources type='positions' defaultValues={selectedCandidates} rateInMail={props.rateInMail} jobId={jobId} ClickHandler={onSubmit} onClose={() => setSubmitResources(false)}/>}
      </>
    );
    }
    
    export default ApplyPositions
